import React, { useEffect, useState } from 'react';
import axios from 'axios';

const DonationsAdminPage = () => {
  const [donations, setDonations] = useState([]);
  const [filter, setFilter] = useState('');
  const [filteredDonations, setFilteredDonations] = useState([]);

  useEffect(() => {
    const fetchDonations = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/donations`);
        setDonations(res.data);
        setFilteredDonations(res.data);
      } catch (err) {
        console.error('Failed to fetch donations:', err);
      }
    };

    fetchDonations();
  }, []);

  const handleFilterChange = (e) => {
    const value = e.target.value.toLowerCase();
    setFilter(value);
    setFilteredDonations(
      donations.filter(
        (d) =>
          d.cause.toLowerCase().includes(value) ||
          d.donationFor.toLowerCase().includes(value)
      )
    );
  };

  const downloadCSV = () => {
    const headers = ['Transaction ID', 'Name', 'Phone', 'Email', 'Amount', 'Cause', 'Donation For', 'Date'];
    const rows = filteredDonations.map((d) => [
      d.transactionId,
      d.name,
      d.phone,
      d.email,
      d.amount,
      d.cause,
      d.donationFor,
      new Date(d.createdAt).toLocaleString()
    ]);

    const csvContent =
      'data:text/csv;charset=utf-8,' +
      [headers.join(','), ...rows.map((r) => r.join(','))].join('\n');

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.href = encodedUri;
    link.download = 'donations.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Donation Transactions</h2>

      <div className="mb-4 flex gap-4">
        <input
          type="text"
          value={filter}
          onChange={handleFilterChange}
          placeholder="Filter by cause or donation for"
          className="border px-4 py-2 rounded w-full md:w-1/2"
        />
        <button onClick={downloadCSV} className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-800">
          Download CSV
        </button>
      </div>

      <div className="overflow-auto">
        <table className="min-w-full border border-gray-300 text-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-2 border">#</th>
              <th className="p-2 border">Transaction ID</th>
              <th className="p-2 border">Name</th>
              <th className="p-2 border">Phone</th>
              <th className="p-2 border">Email</th>
              <th className="p-2 border">Amount</th>
              <th className="p-2 border">Cause</th>
              <th className="p-2 border">Donation For</th>
              <th className="p-2 border">Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredDonations.map((donation, index) => (
              <tr key={donation._id}>
                <td className="p-2 border text-center">{index + 1}</td>
                <td className="p-2 border">{donation.transactionId}</td>
                <td className="p-2 border">{donation.name}</td>
                <td className="p-2 border">{donation.phone}</td>
                <td className="p-2 border">{donation.email || 'N/A'}</td>
                <td className="p-2 border">₹{donation.amount}</td>
                <td className="p-2 border">{donation.cause}</td>
                <td className="p-2 border">{donation.donationFor}</td>
                <td className="p-2 border">{new Date(donation.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {filteredDonations.length === 0 && (
          <p className="text-center text-gray-500 mt-4">No records found.</p>
        )}
      </div>
    </div>
  );
};

export default DonationsAdminPage;
